function getPersonOpk(url) {
  if (!url) {
    return '';
  }
  const match = url.match(/people\/([a-zA-z0-9]+)\/$/);
  if (!match) {
    return '';
  }
  return match[1] || '';
}

export default getPersonOpk;



// WEBPACK FOOTER //
// ../utilities/person.js